import { ChevronLeft, Menu } from "lucide-react";

const DX_LOGO_URL =
  "https://cdn.art-mate.net/uploads/artmate/202502/thumbnail/20250228_160227_1YqJgAgCUS_p_300_0.png";

// F-AA: the sticky top bar shared by the exhibition, zone and exhibit pages.
// Left: the parent link ("‹ zone" / "‹ exhibition"), always one tap away while
// the page scrolls; centre: DX logo; right: the preferences menu.
export default function VisitorHeader({ parentLabel, onParent, onMenu }) {
  return (
    <div className="sticky top-0 bg-black/90 backdrop-blur border-b border-white/10 z-10">
      <div className="max-w-4xl mx-auto px-3 py-2 grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-2">
        <div className="min-w-0">
          {parentLabel && (
            <button
              type="button"
              onClick={onParent}
              className="inline-flex max-w-full items-center gap-1 rounded-full border border-white/15 bg-white/5 py-1.5 pl-1.5 pr-3 text-sm font-medium text-white hover:bg-white/10"
              data-testid="parent-link"
            >
              <ChevronLeft className="h-4 w-4 shrink-0" aria-hidden="true" />
              <span className="truncate">{parentLabel}</span>
            </button>
          )}
        </div>
        <img src={DX_LOGO_URL} alt="DX Logo" className="w-20 object-contain" />
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onMenu}
            className="text-white hover:bg-white/10 rounded-lg p-2"
            data-testid="open-preferences"
          >
            <Menu className="w-7 h-7" strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </div>
  );
}
